export function getView(image_id) {
  return image_id ? 'PreviewImage' : 'Empty'
}
